var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wl-dialog-import" },
    [
      _c(
        "wl-button",
        _vm._b(
          {
            attrs: {
              ret: "open-btn",
              loading: _vm.loading,
              disabled: _vm.disabled,
            },
            on: {
              click: function () {
                return (_vm.visible = true)
              },
            },
          },
          "wl-button",
          _vm.$$deepMerge(_vm.btnOptions, _vm.$attrs),
          false,
          true
        )
      ),
      _c(
        "wl-dialog",
        _vm._b(
          {
            staticClass: "import-dialog",
            attrs: {
              ret: "import-dialog",
              canStretch: false,
              width: _vm.width,
              title: _vm.title,
              open: _vm.visible,
              loading: _vm.loading,
            },
            on: {
              "update:width": function ($event) {
                _vm.width = $event
              },
              "update:title": function ($event) {
                _vm.title = $event
              },
              "update:open": function ($event) {
                _vm.visible = $event
              },
              onOk: _vm.submitFileForm,
            },
          },
          "wl-dialog",
          _vm.$$deepMerge(_vm.dialogOptions, _vm.$attrs),
          false,
          true
        ),
        [
          _c(
            "wl-upload",
            _vm._b(
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                ref: "import-upload",
                staticClass: "import-upload",
                attrs: {
                  width: "100%",
                  disabled: _vm.upload.isUploading,
                  "on-progress": _vm.handleFileUploadProgress,
                  "on-success": _vm.onSuccess,
                },
                scopedSlots: _vm._u([
                  {
                    key: "trigger",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          {
                            staticClass:
                              "upload-trigger-wrapper flex-direction flex-center",
                          },
                          [
                            _c("i", {
                              staticClass:
                                "el-icon-upload flex-fiexd flex-center",
                              staticStyle: {
                                margin: "0",
                                "margin-bottom": "0",
                              },
                            }),
                            _c(
                              "div",
                              { staticClass: "el-upload__text flex-fiexd" },
                              [
                                _vm._v("将文件拖到此处，或"),
                                _c("em", [_vm._v("点击上传")]),
                              ]
                            ),
                            _c(
                              "el-link",
                              {
                                staticClass: "el-upload__text",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return _vm.downloadTemplate($event)
                                  },
                                },
                              },
                              [_c("em", [_vm._v("下载模板")])]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "el-upload__tip",
                                staticStyle: { color: "red" },
                                attrs: { slot: "tip" },
                                slot: "tip",
                              },
                              [
                                _vm._v(
                                  "提示：仅允许导入“xls”或“xlsx”格式文件！"
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              "wl-upload",
              _vm.getUploadOptions,
              false
            ),
            [
              _c("el-checkbox", {
                staticStyle: { color: "grey" },
                attrs: { label: "更新已存在的数据" },
                model: {
                  value: _vm.upload.updateSupport,
                  callback: function ($$v) {
                    _vm.$set(_vm.upload, "updateSupport", $$v)
                  },
                  expression: "upload.updateSupport",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }